export class PqrTracingEntity{
    id:number;
    pqrNumber:string;
    pqrTicket:string;
    pqrTypeId:number;
    pqrType:string;
    type:string;
    eventStatusId:number;
    eventStatus:string;
    observations:string;
    date:string;
    userId:number;
    user:string;

    constructor(){}
}